// === FILE: assets/italiansecret-cart-stock-utils.js ===
// Helpers: parse mappe, GID→SKU, nome topping

window.IS_LOG_PREFIX = "🧩 ItalianSecretCartStock";

// -----------------------------------------------------
// 🔧 Parse JSON da <script id="..."> nel DOM
// -----------------------------------------------------
window.parseJsonFromScript = function(id) {
  try {
    const el = document.querySelector(id);
    if (!el) {
      console.warn(`${IS_LOG_PREFIX} – ${id} not found`);
      return {};
    }
    return JSON.parse(el.textContent || "{}");
  } catch (e) {
    console.error(`${IS_LOG_PREFIX} – Error parsing ${id}:`, e);
    return {};
  }
};

// -----------------------------------------------------
// 📦 Carica tutte le mappe globali dal DOM
// -----------------------------------------------------
window.includedMap = parseJsonFromScript("#is-included-map");
window.stockMap    = parseJsonFromScript("#is-stock-map");
window.gidMap      = parseJsonFromScript("#is-gid-map");
window.nameMap     = parseJsonFromScript("#is-name-map");

// -----------------------------------------------------
// 🔁 Conversione GID → SKU (con normalizzazione sicura)
// -----------------------------------------------------
window.gidToSku = function(gid) {
  if (!gid) return gid;

  // ✅ Se è già un ProductVariant
  if (gid.includes("/ProductVariant/") && gidMap[gid]) {
    return gidMap[gid];
  }

  // ✅ Se è un Product → tenta la conversione automatica in ProductVariant
  if (gid.includes("/Product/") && !gid.includes("/ProductVariant/")) {
    const id = gid.split("/Product/")[1];
    const variantKey = `gid://shopify/ProductVariant/${id}`;
    if (gidMap[variantKey]) return gidMap[variantKey];

    // Se non c'è la variante diretta, prova a risalire al prodotto base
    if (gidMap[gid]) return gidMap[gid];
  }

  // ⚠️ Nessuna corrispondenza trovata
  console.warn(`${IS_LOG_PREFIX} – ⚠️ Could not resolve GID ${gid} to SKU`);
  return null;
};

// -----------------------------------------------------
// 🏷️ Nome umano per SKU (fallback: SKU stesso)
// -----------------------------------------------------
window.toppingLabel = function(sku) {
  return nameMap[sku] || sku;
};

// -----------------------------------------------------
// 🧭 Log di conferma caricamento
// -----------------------------------------------------
console.log(`${IS_LOG_PREFIX} – Utils loaded.`);
console.log("Included map:", window.includedMap);
console.log("Stock map:", window.stockMap);
console.log("GID map:", window.gidMap);
console.log("Name map:", window.nameMap);